export const DEFAULT_PARALLEL_POOL_SIZE = 20;
